module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_long_auburn.2f155b25.png";